import { Connector } from '@web3-wallet/core';
import { icon } from './assets';
const _walletName = 'Coinbase Wallet';
const walletName = _walletName;
export class CoinbaseWallet extends Connector {
    /**
     * {@inheritdoc Connector.constructor}
     *
     * @param options - Options to pass to `@coinbase/wallet-sdk`.
     */
    constructor(options) {
        super(options);
        this.walletName = walletName;
    }
    /** {@inheritdoc Connector.detectProvider} */
    async detectProvider() {
        if (this.provider)
            return this.provider;
        const m = await import('@coinbase/wallet-sdk');
        const { scanToConnectOptions, ...options } = this.options.providerOptions;
        this.coinbaseWallet = new m.default(options);
        this.provider = this.coinbaseWallet.makeWeb3Provider(scanToConnectOptions?.rpcUrl, scanToConnectOptions?.chainId);
        return this.provider;
    }
    get connected() {
        return !!this.provider?.selectedAddress;
    }
    /** {@inheritdoc Connector.autoConnect} */
    async autoConnect() {
        await this.lazyInitialize();
        if (!this.connected) {
            console.debug(`No existing connection`);
            return false;
        }
        return await super.autoConnect();
    }
    /** {@inheritdoc Connector.disconnect} */
    async disconnect(force = true) {
        await super.disconnect();
        if (force) {
            await this.coinbaseWallet?.disconnect();
        }
    }
}
CoinbaseWallet.walletName = walletName;
CoinbaseWallet.walletIcon = icon;
